import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth-service/auth.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import * as moment from 'moment-timezone';
import { animate, style, transition, trigger } from "@angular/animations";
import { MenuService, UserRoles } from '../menu-service/menu.service';
import { Events } from "src/app/utils/event-utils";
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { DispatchCenterService } from 'src/app/component/dashboard/dashboard-service/dispatch-center-service';
import { sweetAlert } from 'src/app/utils/swal';
import { PushToTalkService } from 'src/app/component/push-to-talk/push-to-talk-service/push-to-talk.service';
import { TranslationService } from 'src/app/service/translation-service/translation.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [
    trigger("openCloseProfile", [
      transition(":enter", [
        style({ opacity: 0, transform: "scale(0.95)" }), //apply default styles before animation starts
        animate(
          "500ms ease-in-out",
          style({ opacity: 1, transform: "scale(1)" })
        )
      ]),
      transition(":leave", [
        style({ opacity: 1, }), //apply default styles before animation starts
        animate(
          "300ms ease-in-out",
          style({ opacity: 0, transform: "scale(.95)" })
        )
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('audioOption', { static: true }) audioPlayerRef: ElementRef;
  @ViewChild('messageTone', { static: true }) messageTone: ElementRef;
  @ViewChild('pttTone', { static: true }) pttTone: ElementRef;
  @ViewChild('callTone', { static: true }) callTone: ElementRef;
  subMenus;
  selectedMenuKey: string;
  showUserOptions = false;
  showNotifications = false;
  showMessageNotifications = false;
  currentPath = '';
  isHome = false;
  timeZone;
  showQuickMenu = false;
  showLangMenu = false;
  languages = [
    { code: 'en', labelKey: 'englishLanguageLabel', nativeLabel: 'English', short: 'EN' },
    { code: 'es', labelKey: 'spanishLanguageLabel', nativeLabel: 'Español', short: 'ES' },
    { code: 'zh', labelKey: 'chineseLanguageLabel', nativeLabel: '中文', short: 'ZH' },
    { code: 'pa', labelKey: 'punjabiLanguageLabel', nativeLabel: 'ਪੰਜਾਬੀ', short: 'PA' },
    { code: 'ar', labelKey: 'arabicLanguageLabel', nativeLabel: 'العربية', short: 'AR' },
    { code: 'ur', labelKey: 'urduLanguageLabel', nativeLabel: 'اردو', short: 'UR' }
  ];
  user: any;
  intervalTimeID: any;
  currentTime = moment().toISOString();
  menus;
  isSound = true;
  userRole;
  notificationsCount = 0;
  messageCount = 0;
  dateObj = {};
  now;
  messageDetail = [];
  callModalObj;
  showCallNotification = false;
  showCallModal = false;
  tempCall;
  notificationsMuted: boolean = false;
  canView: boolean = false;

  constructor(
    private sharedDataService: SharedDataService,
    private authService: AuthService,
    private menuService: MenuService,
    private socket: SocketService,
    private router: Router,
    private socketService: SocketService,
    private dispatchCenterService: DispatchCenterService,
    private toastr: ToastrService,
    private pushToTalk: PushToTalkService,
    private translationService: TranslationService
  ) {
    document.addEventListener('keyup', e => {
      console.log(e);
      // e.ctrlKey &&
      if (e.altKey && (e.key.toLowerCase() === 'v' || e.key.toLowerCase() === '√')) {
        this.canView = !this.canView;
      }
    });
  }

  ngOnInit() {
    this.setUpDriverAlertSocketListener();

     this.now = moment().format('L');

    if (localStorage.getItem('currentDate')) {
      const obj = JSON.parse(localStorage.getItem('currentDate'));
      const storedDate = Object.keys(obj)[0];
      if (this.now === storedDate) {
        if(localStorage.getItem('notificationsCount')){
          this.notificationsCount = JSON.parse(localStorage.getItem('notificationsCount'));
          window.addEventListener('storage', this.storageListener);
        }
      } else {
        this.dateObj[this.now] = 0;
        localStorage.setItem('currentDate', JSON.stringify(this.dateObj));
        localStorage.removeItem('notificationsCount');
      }
    } else {
      this.dateObj[this.now] = 0;
      localStorage.setItem('currentDate', JSON.stringify(this.dateObj));
    }
    if (localStorage.getItem('currentDate')) {
      const obj = JSON.parse(localStorage.getItem('currentDate'));
      const storedDate = Object.keys(obj)[0];
      if (this.now === storedDate) {
        if(localStorage.getItem('messageCount')){
          this.messageCount = JSON.parse(localStorage.getItem('messageCount'));
          window.addEventListener('storage', this.storageListener);
        }
      } else {
        this.dateObj[this.now] = 0;
        localStorage.setItem('currentDate', JSON.stringify(this.dateObj));
        localStorage.removeItem('messageCount');
      }
    } else {
      this.dateObj[this.now] = 0;
      localStorage.setItem('currentDate', JSON.stringify(this.dateObj));
    }

    this.getUser();
    this.router.events
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          if (event.url) {
            let path = event.url;
            this.currentPath = path.substring(1);
            this.getSubMenus();
          }
        }
      });
    this.getSubMenus();

    this.intervalTimeID = setInterval(() => {
      this.currentTime = moment().toISOString();
    }, 1000);

    this.socketService.addListener(Events.SEND_EXPIRE_DISPATCH)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.sucess) {
          this.onAudioPlay();
          this.getNotificationsList();

        }
      });

    if (localStorage.getItem("sound")) {
      this.isSound = JSON.parse(localStorage.getItem("sound"));
    }
    if (localStorage.getItem("notificationsMuted")) {
      this.notificationsMuted = JSON.parse(localStorage.getItem("notificationsMuted"));
    }

  }

  storageListener = (event) => {
    if (event.key === 'sound') {
      if (event.newValue) {
        this.isSound = JSON.parse(event.newValue);
      }
    }


  }

  getNotificationsList() {
    this.dispatchCenterService
      .getNotifications()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {

        if (data) {
          this.notificationsCount++;
          localStorage.setItem('notificationsCount', JSON.stringify(this.notificationsCount))
          // localStorage.setItem('currentDate', JSON.stringify(this.dateObj));
          if (this.menus && (this.menus.dashboard || this.menus.operations || this.menus.trips || this.menus.manifest)) {
            const notifications = data[0];
            if (!this.notificationsMuted) {
              this.toastr.success(notifications.text, 'Alert');
            }
          }
        }
      });
  }

  setUpDriverAlertSocketListener() {
    this.socketService.addListener(Events.RECEIVE_DRIVER_ALERT_MESSAGE_CALL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        console.log("data check",data)
        if (data.success) {
          this.messageCount++;
          localStorage.setItem('messageCount', JSON.stringify(this.messageCount))
          // localStorage.setItem('currentDate', JSON.stringify(this.dateObj));
          if (this.menus && (this.menus.dashboard || this.menus.operations || this.menus.trips || this.menus.manifest)) {
            const notifications = data;
            this.messageDetail.push(data);
            this.toastr.success(notifications.message + " By " + notifications.driverAlert.sender.displayName, 'Alert');
            this.onMessagePlay();

          }
        }
      });


    this.socketService.addListener(Events.PUSH_TO_TALK)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        console.log("data check", data)
        let isStaff = this.user && this.user.sId ? true : false;
        if (isStaff && data.type === 'cnew') {
          return; // ignore cmessage if received for the company.
        }
        this.toastr.success("Voice message" + " by " + data.pushtotalkmessage.sender.displayName, 'Alert');
        this.playAudio(data.pushtotalkmessage.fileURL);
        this.onPttPlay();
        this.markAsReadMessage(data.pushtotalkmessage._id);
      });


    this.socketService.addListener(Events.DRIVER_CALL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        console.log(data);
        if (data) {
          if (data.status === 'join') {
            if (this.callModalObj) {
              return;
            }
            this.callModalObj = data;
            if (this.user._id === this.callModalObj.sender._id) {
              this.onCallTuneStop();
              this.showCallModal = true;
            } else {
              this.showCallNotification = true
              this.onCallTunePlay();
            }
          } else if (data.status === 'accept') {
            if (this.callModalObj && this.callModalObj.roomId === data.roomId){
              this.showCallNotification = false;
              this.callModalObj = null;
              this.onCallTuneStop();
            }

          } else if(data.status === 'leave'){
            if (this.callModalObj && this.callModalObj.roomId === data.roomId){
              this.showCallNotification = false;
              this.showCallModal = false;
              this.callModalObj = null;
              this.callTone.nativeElement.pause();
            }
          }
        }
        else {
          sweetAlert('Error', data.message, 'error', 'OK');

        }

      });
  }

  playAudio(audioUrl): void {
    if (audioUrl) {
      const audio = new Audio(audioUrl);
      audio.play();
    }
  }

  onAudioPlay() {
    if (this.isSound) {
      this.audioPlayerRef.nativeElement.play();
    }
  }
  onMessagePlay() {
    if (this.isSound) {
      this.messageTone.nativeElement.play();
    }
  }
  onPttPlay() {
    if (this.isSound) {
      this.pttTone.nativeElement.play();
    }
  }
  onCallTunePlay() {
    if (this.isSound) {
      this.callTone.nativeElement.play();
    }
  }
  onCallTuneStop() {
    if (this.isSound) {
      this.callTone.nativeElement.pause();
    }
  }
    toggleMute() {
    this.notificationsMuted = !this.notificationsMuted;
    localStorage.setItem("notificationsMuted", JSON.stringify(this.notificationsMuted));
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = user.timeZone;
          if (this.user && this.user.roles) {
            if ((typeof this.user.roles) === 'string') {
              if (this.user.sRoles) {
                this.userRole = this.menuService.getUserRoleTitle(this.user.sRoles);
                this.menus = this.menuService.getMenu(this.user.sRoles, this.user);
              } else {
                this.userRole = this.menuService.getUserRoleTitle(this.user.roles);
                this.menus = this.menuService.getMenu(this.user.roles, this.user);
              }
            } else if ((typeof this.user.roles) === 'object') {
              this.userRole = this.menuService.getUserRoleTitle(this.user.roles[0]);
              this.menus = this.menuService.getMenu(this.user.roles[0], this.user);
            }
          }
        }
      });
  }

  getSubMenus() {
    this.sharedDataService
      .getSubMenus()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.subMenus = [];
        if (data) {
          this.selectedMenuKey = data.key;
          this.isHome = this.currentPath === data.key ? true : false;
          if (data.subMenus) {
            this.subMenus = data.subMenus;
          }
        } else {
          this.selectedMenuKey = null;
        }
      });
  }

  onQuickMenuClick(menuKey) {
    this.subMenus = [];
    const menu = this.menus[menuKey];
    this.sharedDataService.saveSubMenus(menu ? menu : null);

    // if (menu) {
    //   this.subMenus = menu.subMenus;
    // }
  }

  logout() {
    this.socket.disconnectSocket();
    this.authService.removeToken();
    this.sharedDataService.saveUser(null);
    this.router.navigateByUrl('login');
  }

  viewSmallScreenMenu() {
    this.sharedDataService.setSmallScreenMenuState(true);
  }

  onClickDropdownMenu() {
    this.sharedDataService.saveSubMenus(null);
    this.showUserOptions = !this.showUserOptions
  }

  toggleSound() {
    this.isSound = !this.isSound;
    localStorage.setItem("sound", JSON.stringify(this.isSound));
  }

  canViewSubmenu(subMenus, title) {
    let isFound = false;
    if (subMenus && subMenus.length) {
      isFound = subMenus.some(m => (m.titleKey || m.title) === title);
    }
    return isFound;
  }
  toggleNotifications() {
    this.showNotifications = !this.showNotifications;
    this.notificationsCount = null;
    localStorage.removeItem('notificationsCount');
  }
  toggleMessageNotifications() {
    this.showMessageNotifications = !this.showMessageNotifications;
    this.messageCount = null;
    localStorage.removeItem('messageCount');
  }

  closeCallNotificationModal(evt:any){
    console.log("event check",evt);
    this.onCallTuneStop();
    if(evt){
      this.showCallNotification = false;
      this.showCallModal = true
    }else{
      this.showCallNotification = false;
    }

  }

  markAsReadMessage = (pushtotalkmessageId) => {
    this.pushToTalk.markAsReadMessage({ pushtotalkmessageId }).pipe(takeUntil(componentDestroyed(this))).subscribe((data) => {
      if (data) {
      }
    })
  };

  getCurrentLocale(): string {
    return this.translationService.getLocale();
  }

  getCurrentLanguage() {
    return this.languages.find(l => l.code === this.getCurrentLocale()) || this.languages[0];
  }

  changeLanguage(locale: string) {
    this.translationService.setLocale(locale);
    this.showLangMenu = false;
    this.refreshMenus();
  }

  private refreshMenus() {
    if (!this.user || !this.user.roles) {
      return;
    }
    if ((typeof this.user.roles) === 'string') {
      if (this.user.sRoles) {
        this.menus = this.menuService.getMenu(this.user.sRoles, this.user);
      } else {
        this.menus = this.menuService.getMenu(this.user.roles, this.user);
      }
    } else if ((typeof this.user.roles) === 'object') {
      this.menus = this.menuService.getMenu(this.user.roles[0], this.user);
    }

    if (this.selectedMenuKey && this.menus && this.menus[this.selectedMenuKey]) {
      this.sharedDataService.saveSubMenus(this.menus[this.selectedMenuKey]);
    }
  }



  ngOnDestroy(): void {
    if (this.intervalTimeID) {
      clearInterval(this.intervalTimeID);
    }
  }
}
